import React from 'react';
import PropTypes from 'prop-types';
import { useColumnStyles } from './hooks';

export default function AccordionColumn({ className, children: childrenProp }) {
  const colStyles = useColumnStyles();
  return <div className={`${colStyles.col} ${className}`.trim()}>{childrenProp}</div>;
}

AccordionColumn.defaultProps = {
  className: '',
};

AccordionColumn.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
};
